import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchProjectStatuses } from '../../api/testScenarioApi'

// Async thunk for fetching project statuses
export const fetchProjectStatusesAsync = createAsyncThunk(
  'projectStatuses/fetchProjectStatuses',
  async (projectId, { rejectWithValue }) => {
    try {
      const data = await fetchProjectStatuses(projectId)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

const initialState = {
  statuses: [], // Array of status objects
  loading: false,
  error: null
}

const projectStatusesSlice = createSlice({
  name: 'projectStatuses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectStatusesAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchProjectStatusesAsync.fulfilled, (state, action) => {
        state.loading = false
        state.statuses = action.payload
        state.error = null
      })
      .addCase(fetchProjectStatusesAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

// Selectors
export const selectProjectStatuses = (state) => state.projectStatuses.statuses
export const selectProjectStatusesLoading = (state) => state.projectStatuses.loading
export const selectProjectStatusesError = (state) => state.projectStatuses.error

export default projectStatusesSlice.reducer

